import { useQuery } from '@tanstack/react-query';
import { fetchMyPendingCorrections } from '../api/myCorrectionsApi';
import { correctionKeys } from './correctionKeys';

export function usePendingCorrectionDates(startDate: string, endDate: string): ReadonlySet<string> {
  const query = useQuery({
    queryKey: correctionKeys.myPending(startDate, endDate),
    queryFn: () => fetchMyPendingCorrections(startDate, endDate),
    staleTime: 0,
    refetchOnMount: 'always',
  });
  return new Set(
    query.data?.data
      .filter((correction) => correction.status === 'PENDING')
      .map((correction) => correction.attendanceId)
  );
}
